import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  extendTimerReqForEdit: {
    id: undefined,
    expiredTimeStamp: "",
    bidAmount: "",
    status: "",
    sendTimeStamp: "",
    negotiation: null,
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const extendTimerReqSlice = createSlice({
  name: "extendTimerReq",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // location loader
    timerReqListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    timerReqList: (state, action) => {
      const { result, count } = action.payload;

      let tempArray = [];

      result.forEach(item => {
        let tempObj = {
          id: item.id,
          requestDays: item.requestDays,
          requestHours: item.requestHours,
          requestTime: item.requestTime,
          reason: item.extendTimeReason,
          createdBy: item.createdBy,
          status: item.status,
          bid: item.bid,
        };

        tempArray.push(tempObj);
      });

      state.totalCount = count;
      state.entities = tempArray;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    timerReqListEdit: (state, action) => {
      let temp = {
        id: action.payload.id,
        expiredTimeStamp: action.payload.expiredTimeStamp,
        bidAmount: action.payload.bidAmount,
        status: action.payload.status,
        sendTimeStamp: action.payload.sendTimeStamp,
        negotiation: action.payload.negotiation,
      };

      state.wantToBuyForEdit = temp;
    },
    loadtimerReqMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
  },
});
